<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="720"
    scrollable
  >
    <v-card class="chat-popup">
      <header class="chat-popup__header">
        <span class="chat-popup__icon">
          <v-icon size="23">mdi-message-text-outline</v-icon>
        </span>
        <div>
          <h2>{{ chatTitle }}</h2>
          <p>{{ chatSubtitle }}</p>
        </div>
        <button
          type="button"
          class="chat-popup__close"
          aria-label="Закрити чат"
          @click="closePopup"
        >
          <v-icon color="#667085" size="22">mdi-close</v-icon>
        </button>
      </header>

      <Chat
        :chatId="popupContext.chatId"
        :fromUser="popupContext.user"
        :toUser="popupContext.student"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import popupEnum from '@/enums/popupEnum';
import PopupEventEnum from '@/enums/PopupEventEnum';
import Chat from '@/components/View/Chat/Chat';

export default {
  name: popupEnum.CHAT_POPUP,
  components: { Chat },
  props: {
    popupContext: {
      type: Object,
      requred: true,
    },
  },
  data() {
    return {
      dialog: true,
    };
  },
  watch: {
    dialog(val) {
      const type = val ? PopupEventEnum.OPEN_POPUP : PopupEventEnum.CLOSE_POPUP;
      this.$emit('popupEvent', {
        type,
      });
    },
  },
  computed: {
    isTeacherApp() {
      return this.$store.getters['ConfigStore/isTeacherApp'];
    },
    chatTitle() {
      return this.isTeacherApp ? 'Чат з учнем' : 'Чат з вчителем';
    },
    chatSubtitle() {
      return this.isTeacherApp
        ? 'Обговоріть з учнем завдання до уроку'
        : 'Поставте запитання щодо уроку';
    },
  },
  mounted() {},
  destroyed() {
    this.closePopup();
  },
  methods: {
    closePopup() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
.chat-popup {
  border-radius: 18px !important;
  overflow: hidden;
}
.chat-popup__header {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid var(--theme-border-decorative);
  display: flex;
  gap: 13px;
  padding: 18px 20px;
}
.chat-popup__icon {
  align-items: center;
  background: var(--theme-surface-decorative);
  border-radius: 11px;
  display: flex;
  flex: 0 0 auto;
  height: 44px;
  justify-content: center;
  width: 44px;
}
.chat-popup__icon::v-deep .v-icon {
  color: var(--theme-banner-text) !important;
}
.chat-popup__header h2 {
  color: #172033;
  font-size: 19px;
  line-height: 1.25;
  margin: 0;
}
.chat-popup__header p {
  color: #7a8592;
  font-size: 13px;
  margin: 3px 0 0;
}
.chat-popup__close {
  align-items: center;
  background: #f4f6f7;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  margin-left: auto;
  width: 40px;
}
.chat-popup__close:hover {
  background: var(--theme-surface-decorative);
}
@media (max-width: 600px) {
  .chat-popup {
    border-radius: 0 !important;
  }
  .chat-popup__header {
    padding: 14px 16px;
  }
}
</style>
